import { ICard } from '../../../../../../../../../store/model/card/types';

export const getCardTimeSinceMovedToList = (
    card: ICard
): number => {
    const { moveInListDate } = card;
    return moveInListDate;
}
